"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.FindYourProductSkeleton = void 0;
var _testidGenerator = _interopRequireDefault(require("@ori/testid-generator"));
var _times = _interopRequireDefault(require("es-toolkit/compat/times"));
var _hooks = require("../../../hooks");
var _constant = require("./constant");
var _styles = require("./styles");
var _jsxRuntime = require("react/jsx-runtime");
const FindYourProductSkeleton = ({
  animation
}) => {
  const {
    getTestId
  } = (0, _testidGenerator.default)();
  const isMobile = (0, _hooks.useIsMobile)();
  if (isMobile) {
    return /*#__PURE__*/(0, _jsxRuntime.jsx)(_styles.Root, {
      "data-testid": getTestId(_constant.FIND_YOUR_PRODUCT_MOBILE_SKELETON),
      children: (0, _times.default)(5).map(index => /*#__PURE__*/(0, _jsxRuntime.jsx)(_styles.MobileTileSkeleton, {
        animation: animation,
        variant: "text",
        height: 28,
        width: 130
      }, `mobile-tile-${index}`))
    });
  }
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_styles.Root, {
    "data-testid": getTestId(_constant.FIND_YOUR_PRODUCT_DESKTOP_SKELETON),
    children: (0, _times.default)(_constant.MAX_NUMBER_OF_TILES).map(index => /*#__PURE__*/(0, _jsxRuntime.jsx)(_styles.DesktopTileSkeleton, {
      animation: animation
    }, `desktop-tile-${index}`))
  });
};
exports.FindYourProductSkeleton = FindYourProductSkeleton;